import { render, staticRenderFns } from "./UsersLogs.vue?vue&type=template&id=8aafebec&"
import script from "./UsersLogs.vue?vue&type=script&lang=js&"
export * from "./UsersLogs.vue?vue&type=script&lang=js&"
import style0 from "./UsersLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports